module.exports = __webpack_public_path__ + "static/media/phone_darkbleu.ba2f36e1.svg";